module.exports = "https://coursera_assets.s3.amazonaws.com/images/426dbeca67d16181a4bb87e4928faebb.png";